module.exports = __webpack_public_path__ + "img/MS_WeaponSword007.822ac2c3.png";